import { inject, Injectable } from '@angular/core';
import { SentryLoggerService } from 'app/services/data/sentry-logger.service';
import { OverlayService } from 'app/services/utilities/overlay.service';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ConnectivityService {
    private online$ = new BehaviorSubject<boolean>(navigator.onLine); // ✅ état initial pris en compte
    private _loadingService = inject(OverlayService);
    private _sentryLoggerService = inject(SentryLoggerService);

    constructor() {
        merge(
            fromEvent(window, 'online').pipe(map(() => true)),
            fromEvent(window, 'offline').pipe(map(() => false))
        ).subscribe(online => {
            this.online$.next(online);
            online ? this._internetRecovered() : this._internetLost();
        });
    }

    private _internetLost() {
        // this._sentryLoggerService.log('Internet', 'Lost');
        this._loadingService.showInternetLost();
    }

    private _internetRecovered() {
        // this._sentryLoggerService.log('Internet', 'Recovered');
        this._loadingService.hide();
    }

    /**
     * Observable de l'état de connectivité.
     */
    public isOnline(): Observable<boolean> {
        return this.online$.asObservable();
    }

    /**
     * État actuel de la connectivité.
     */
    public getCurrentOnlineStatus(): boolean {
        return navigator.onLine;
    }
}
